import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import animated from "animate.css"
import VueAwesomeSwiper from 'vue-awesome-swiper'
import "swiper/dist/css/swiper.css";
import store from './framework/store'
import { post } from '@/framework/http/request'
Vue.prototype.axios = axios;
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(animated)
Vue.config.productionTip = false
Vue.prototype.$post = post;
Vue.use(ElementUI);
/* eslint-disable no-new */
/* 图片url前缀判断*/
router.afterEach((to, from, next) => {

  window.scrollTo(0, 0)

});
console.log(process.env.NODE_ENV);
let baseURL = ''
if (process.env.NODE_ENV === 'testing') {
  baseURL = 'http://8.135.31.28:8181'
} else if (process.env.NODE_ENV === 'production') {
  baseURL = 'http://8.135.31.28:8181'
} else {
  baseURL = '/'
}
axios.defaults.baseURL = baseURL
axios.defaults.withCredentials = true;
window.imgPrefix = process.env.NODE_ENV === 'production' ? 'https://qiniu.hicoostart.com/' : 'https://qiniu.hicoostart.com/'
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js